// Angular imports
import { NgModule, ModuleWithProviders, Type } from '@angular/core';
import { CommonModule } from '@angular/common';

// 3rd party imports
import {
    DxBoxModule,
    DxTileViewModule,
    DxScrollViewModule,
    DxPopoverModule,
    DxSelectBoxModule,
    DxPopupModule,
    DxToolbarModule,
    DxButtonModule,
    DxContextMenuModule,
    DxFormModule,
    DxListModule,
    DxLoadPanelModule,
    DxMultiViewModule,
    DxCheckBoxModule,
    DxValidatorModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxDataGridModule,
    DxDropDownButtonModule,
    DxTabsModule,
    DxTagBoxModule,
    DxTextBoxModule
} from 'devextreme-angular';
import { AngularSplitModule } from 'angular-split';

// Module & Component imports
import { CCCommonModule } from 'cc-common';
import { SharedModule } from '../shared-module/shared.module';
import { ManagementCommonModule } from '../management-common/management-common.module';
import { DynamicDashboardComponent } from './dynamic-dashboard/dynamic-dashboard.component';
import { DashboadCreatorComponent } from './dashboard-creator/dashboard-creator.component';
import { DashboardViewerComponent } from './dashboard-viewer/dashboard-viewer.component';
import { TabbedDashboardEditorComponent } from './tabbed-dashboard-editor/tabbed-dashboard-editor.component';
import { TabbedDashboardViewerComponent } from './tabbed-dashboard-viewer/tabbed-dashboard-viewer.component';
import { MissingWidgetComponent } from './missing-widget/missing-widget.component';
import { SharedWorkspacesComponent } from './shared-workspaces/shared-workspaces.component';

// Directive imports
import { DynamicDashboardTemplateDirective } from './_directives/dynamic-dashboard-template.directive';

// Service imports
import { DynamicDashboardService } from './_services/dynamic-dashboard.service';

// Model imports
import { IDynamicDashboardWidgetsFactory } from './_interfaces/dynamic-dashboard-widgets-factory';
import { SystemDashboardsFactory } from './_interfaces/system-dashboards-factory';
import { ILocalContextFactory } from './_interfaces/local-context-factory';
import { DashboardRenameComponent } from './dashboard-rename/dashboard-rename.component';

@NgModule({
    imports: [
        CommonModule,
        AngularSplitModule.forRoot(),
        DxBoxModule,
        DxPopupModule,
        DxToolbarModule,
        DxButtonModule,
        DxCheckBoxModule,
        DxTileViewModule,
        DxScrollViewModule,
        DxPopoverModule,
        DxPopupModule,
        DxSelectBoxModule,
        DxContextMenuModule,
        DxFormModule,
        DxListModule,
        DxLoadPanelModule,
        DxMultiViewModule,
        DxValidatorModule,
        DxDropDownBoxModule,
        DxTreeViewModule,
        DxDataGridModule,
        DxDropDownButtonModule,
        DxTabsModule,
        DxTagBoxModule,
        DxTextBoxModule,
        CCCommonModule,
        SharedModule,
        ManagementCommonModule
    ],
    declarations: [
        DashboadCreatorComponent,
        DashboardViewerComponent,
        TabbedDashboardEditorComponent,
        TabbedDashboardViewerComponent,
        DynamicDashboardComponent,
        MissingWidgetComponent,
        SharedWorkspacesComponent,
        DynamicDashboardTemplateDirective,
        DashboardRenameComponent
    ],
    entryComponents: [MissingWidgetComponent],
    exports: [DashboardViewerComponent, TabbedDashboardViewerComponent, MissingWidgetComponent]
})
export class DashboardModule {
    static forFeature(
        storageKey: string,
        widgetsFactory: Type<IDynamicDashboardWidgetsFactory>,
        dashboardsFactory: Type<SystemDashboardsFactory>,
        localContextFactory?: Type<ILocalContextFactory>
    ): ModuleWithProviders {
        return {
            ngModule: DashboardModule,
            providers: [
                { provide: 'StorageKey', useValue: storageKey },
                { provide: 'WidgetsFactory', useClass: widgetsFactory },
                { provide: 'DashboardsFactory', useClass: dashboardsFactory },
                { provide: 'LocalContextFactory', useExisting: localContextFactory },
                { provide: DynamicDashboardService, useClass: DynamicDashboardService }
            ]
        };
    }
}
